export var ContainerEvent;
(function (ContainerEvent) {
    /**
     * <zh/> 按下键盘时触发
     *
     * <en/> Triggered when the keyboard is pressed
     */
    ContainerEvent["KEY_DOWN"] = "keydown";
    /**
     * <zh/> 抬起键盘时触发
     *
     * <en/> Triggered when the keyboard is lifted
     */
    ContainerEvent["KEY_UP"] = "keyup";
})(ContainerEvent || (ContainerEvent = {}));
//# sourceMappingURL=container.js.map